<template>
    <p class="text-list text-justify">
        <template v-for="(item, index) in items">
            <span v-html="item" class="text-list__item" :key="'item' + index"></span>.
        </template>
    </p>
</template>

<script>
export default {
    name: 'TextList',
    props: {
        items: {
            type: Array,
            require: true
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/mixins';

p.text-list {
    &__item {
        word-wrap: break-word; //to prevent mobile horizontal bar caused by too long text
    }
}
</style>
